<script>
  import { showImagePreviewModal, previewImageObj } from "../../stores";
  import NotificationModal from "./NotificationModal.svelte";

  $: if ($showImagePreviewModal) {
    enableClosePreviewWithESC();
  }

  const enableClosePreviewWithESC = () => {
    document.onkeydown = (event) => {
      if (event.key === "Escape") {
        closePreviewModal();
        document.onkeydown = null;
      }
    };
  };

  const closePreviewModal = () => {
    $showImagePreviewModal = false;
    $previewImageObj = {};
  };
</script>

<NotificationModal
  title={$previewImageObj.previewTitle ?? "Image Preview"}
  isModalOpen={$showImagePreviewModal}
  showCancelBtn={false}
  submitText="OK"
  confirmAction={closePreviewModal}
  closeModalFunction={closePreviewModal}
  modalMaxWidth="max-w-full w-5/6 h-5/6"
  noContentPadding
>
  <div class="relative overflow-y-auto flex-1 p-6">
    <div class="w-full h-full">
      <img
        class="object-contain w-full h-full"
        src={$previewImageObj.imageContent}
        alt={$previewImageObj.alt ?? "image"}
      />
    </div>
  </div>
</NotificationModal>
